const RUBIKA_USERNAME_PATTERN = /^[a-zA-Z0-9_]{3,32}$/;

export function normalizeRubikaUsername(value) {
  let text = String(value == null ? '' : value).trim();
  if (!text) {
    return '';
  }

  const faDigits = '۰۱۲۳۴۵۶۷۸۹';
  text = text.replace(/[۰-۹]/g, (digit) => String(faDigits.indexOf(digit)));
  text = text.replace(/^@+/, '');

  const urlMatch = text.match(/^https?:\/\/(?:www\.)?rubika\.ir\/([^/?#]+)/i);
  if (urlMatch) {
    return urlMatch[1].replace(/\/+$/, '');
  }

  const shortMatch = text.match(/^rubika\.ir\/([^/?#]+)/i);
  if (shortMatch) {
    return shortMatch[1].replace(/\/+$/, '');
  }

  return text.replace(/\/+$/, '');
}

export function isRubikaUsername(value) {
  const username = normalizeRubikaUsername(value);
  if (!username) {
    return true;
  }
  return RUBIKA_USERNAME_PATTERN.test(username);
}

export function rubikaProfileUrl(value) {
  const username = normalizeRubikaUsername(value);
  if (!username || !RUBIKA_USERNAME_PATTERN.test(username)) {
    return '';
  }
  return `https://rubika.ir/${username}`;
}

const RUBIKA_LEGACY_KEYS = {
  rubika: 'whatsapp',
  rubika_admin: 'whatsapp_admin',
  rubika_admin_text: 'whatsapp_admin_text',
  rubika_shop: 'whatsapp_shop',
  rubika_shop_text: 'whatsapp_shop_text',
};

function looksLikeIranMobile(value) {
  const digits = String(value).replace(/\D/g, '');
  return /^09\d{9}$/.test(digits) || /^989\d{9}$/.test(digits);
}

/** Read rubika_* from options, with legacy whatsapp_* fallback when value is a username. */
export function readRubikaOption(options, key) {
  if (!options || !key) {
    return '';
  }
  const current = options[key];
  if (current) {
    return current;
  }
  const legacyKey = RUBIKA_LEGACY_KEYS[key];
  if (!legacyKey || !options[legacyKey]) {
    return '';
  }
  if (key.indexOf('_text') !== -1) {
    return String(options[legacyKey]).replace(/واتساپ/g, 'روبیکا');
  }
  if (looksLikeIranMobile(options[legacyKey])) {
    return '';
  }
  const username = normalizeRubikaUsername(options[legacyKey]);
  return RUBIKA_USERNAME_PATTERN.test(username) ? username : '';
}
